import {
  IDeliveryAtualizarForm,
  IDeliveryForm,
} from "./../../types/delivery.d";
import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import { removeEmpty } from "../../utils/removeEmpty";
import { IDeliveryDTO, IPageDeliveryDTO } from "../../types/delivery";

import { IPageRequest } from "../../types/page";

const basePath = "/delivery";

export interface IGetDeliveryProps extends IPageRequest {
  cidade?: string;
  uf?: string;
}

export class Delivery {
  static async get(
    props?: IGetDeliveryProps
  ): Promise<AxiosResponse<IPageDeliveryDTO>> {
    let params = "";
    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values).toString();
    }
    return ApiBrave.get(params ? `${basePath}?${params}` : basePath);
  }

  static async getById({
    uuidDelivery,
  }: {
    uuidDelivery: string;
  }): Promise<AxiosResponse<IDeliveryDTO>> {
    return ApiBrave.get(`${basePath}/${uuidDelivery}`);
  }

  static async getDiasIndisponiveis({
    uuidDelivery,
  }: {
    uuidDelivery: string;
  }): Promise<AxiosResponse<string[]>> {
    return ApiBrave.get(`${basePath}/${uuidDelivery}/dias-indiponiveis`);
  }

  static async getHorariosDisponiveis({
    uuidDelivery,
    dataAgendamento,
  }: {
    uuidDelivery: string;
    dataAgendamento: string;
  }): Promise<AxiosResponse<string[]>> {
    return ApiBrave.get(
      `${basePath}/${uuidDelivery}/horarios-disponiveis?dataAgendamento=${dataAgendamento}`
    );
  }

  static async atualizar(
    data: IDeliveryAtualizarForm
  ): Promise<AxiosResponse<IDeliveryDTO>> {
    const { uuidDelivery, ...rest } = data;
    return ApiBrave.put(`${basePath}/${uuidDelivery}/atualizar`, rest);
  }

  static async cadastro(
    data: IDeliveryForm
  ): Promise<AxiosResponse<IDeliveryDTO>> {
    return ApiBrave.post(`${basePath}`, data);
  }
}
